var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateUnactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18582 0C3.56055 0 3.05367 0.506878 3.05367 1.13214V2.28423H2.57589C1.15326 2.28423 0 3.44226 0 4.87075V13.9236C0 15.3521 1.15326 16.5101 2.57589 16.5101H12.8794C14.3021 16.5101 15.4553 15.3521 15.4553 13.9236V4.87075C15.4553 3.44226 14.3021 2.28423 12.8794 2.28423H12.5263V1.04211C12.5263 0.46657 12.0598 0 11.4842 0C10.9087 0 10.4421 0.46657 10.4421 1.04211V2.28423H5.31796V1.13214C5.31796 0.506878 4.81108 0 4.18582 0ZM2.57589 4.28423H12.8794C13.1897 4.28423 13.4553 4.53905 13.4553 4.87075V13.9236C13.4553 14.2553 13.1897 14.5101 12.8794 14.5101H2.57589C2.26559 14.5101 2 14.2553 2 13.9236V4.87075C2 4.53905 2.26559 4.28423 2.57589 4.28423ZM6.59556 6.85581C6.59556 6.2779 6.12707 5.8094 5.54915 5.8094H4.20746C3.62954 5.8094 3.16104 6.2779 3.16104 6.85581C3.16104 7.43373 3.62954 7.90223 4.20746 7.90223H5.54915C6.12707 7.90223 6.59556 7.43373 6.59556 6.85581Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateUnactive);
export default __webpack_public_path__ + "static/media/date-unactive.4c6ae4bd1fa9c82cc50cf3b5d2245f99.svg";
export { ForwardRef as ReactComponent };